import { AbstractControl } from '@angular/forms';

export interface NumberValidator {
  validNumber: boolean;
}

export function validateNumber(control: AbstractControl): NumberValidator | null {
  if (
    control.value === null ||
    control.value === undefined ||
    control.value === '' ||
    isNaN(Number.parseFloat(control.value)) ||
    (typeof control.value === 'string' && (control.value.endsWith('.') || control.value.endsWith(',')))
  ) {
    return { validNumber: false };
  }
  return null;
}
